module.exports = __webpack_public_path__ + "static/media/cyy.21131dcd.png";